export const getDashboardCardColors = (title: string) => {
  switch (title) {
    case 'Pending review':
      return 'bg-secondary-500';
    case 'Connections':
      return 'bg-green-600';
    case 'Conversations':
      return 'bg-theme-blue-600';
    case 'High compatibility':
      return 'bg-primary-400';
    default:
      return 'bg-secondary-500';
  }
};

export const getAiMatchAnalyticsColors = (index: number) => {
  switch (index) {
    case 0:
      return {
        bg: 'bg-primary-25',
        text: 'text-primary-500',
      };
    case 1:
      return {
        bg: 'bg-secondary-25',
        text: 'text-secondary-500',
      };
    case 2:
      return {
        bg: 'bg-theme-blue-25',
        text: 'text-theme-blue-600',
      };
  }
};
